import React from 'react';
import PropTypes from 'prop-types';
import { AvForm } from 'availity-reactstrap-validation';
import './traceabilities.scss';

import { Row } from 'reactstrap';

const IForm = ({ selectedRow, onCreate, onUpdate, onDelete }: any) => {
  const columsPop = 3;
  const columsPop1 = 1;
  const columsPop2 = 3;

  return (
    <>
      <div className="formContainerIFormLogs d-flex flex-column justify-content-evenly´ mt-2">
        <Row className="upRownIFormLogs ps-3 me-1">
          <AvForm
            className="custom-form mt-0"
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${columsPop}, 10fr)`,
              gridAutoRows: 'minmax(10%, 50px)',
              gridGap: '1%',
              padding: '0',
              textAlign: 'center',
            }}
          >
            {selectedRow.id && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Id </label>
                <label className="labelInfoModal"> {selectedRow.id}</label>
              </div>
            )}
            {selectedRow.taskId && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Task Id </label>
                <label className="labelInfoModal"> {selectedRow.taskId}</label>
              </div>
            )}
            {selectedRow.Operation && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Operation </label>
                <label className="labelInfoModal">
                  {' '}
                  {selectedRow.Operation}
                </label>
              </div>
            )}
            {selectedRow.Number && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Number </label>
                <label className="labelInfoModal"> {selectedRow.Number}</label>
              </div>
            )}
            {selectedRow.ClientId && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Client Id </label>
                <label className="labelInfoModal">
                  {' '}
                  {selectedRow.ClientId}
                </label>
              </div>
            )}
            {selectedRow.createdAt && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Created At </label>
                <label className="labelInfoModal">
                  {' '}
                  {selectedRow.createdAt}
                </label>
              </div>
            )}
            {selectedRow.user && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> User </label>
                <label className="labelInfoModal"> {selectedRow.user}</label>
              </div>
            )}
            {selectedRow.text1 && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Detail </label>
                <label className="labelInfoModal"> {selectedRow.text1}</label>
              </div>
            )}
            {selectedRow.text2 && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Additional Detail </label>
                <label className="labelInfoModal"> {selectedRow.text2}</label>
              </div>
            )}
          </AvForm>
        </Row>
        <Row className="centerRownIFormLogs">
          <AvForm
            className="custom-form mt-0"
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${columsPop1}, 1fr)`,
              gridAutoRows: 'minmax(10%, 80px)',
              gridGap: '2%',
              padding: '0',
              textAlign: 'center',
            }}
          >
            {selectedRow.text3 && (
              <div className="d-inline-block text-break d-flex flex-column align-items-center justify-content-center">
                <label className="labelModal"> Advanced Detail </label>
                <label className="labelInfoModal text-break text-wrap">
                  {' '}
                  {selectedRow.text3}
                </label>
              </div>
            )}
            {/* {
              selectedRow.dateOfi && <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Date Ofi </label>
                <label className="labelInfoModal">  {selectedRow.dateOfi}</label>
              </div>
            }
            {
              selectedRow.timeOfi && <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Time Ofi  </label>
                <label className="labelInfoModal">  {selectedRow.timeOfi}</label>
              </div>
            } */}
          </AvForm>
        </Row>

        <Row className="DownRownIFormLogs ps-3 me-1">
          <AvForm
            className="custom-form mt-0"
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${columsPop2}, 10fr)`,
              gridAutoRows: 'minmax(10%, 50px)',
              gridGap: '1%',
              padding: '0',
              textAlign: 'center',
            }}
          >
            {selectedRow.text4 && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Detail 4 </label>
                <label className="labelInfoModal"> {selectedRow.text4}</label>
              </div>
            )}
            {selectedRow.text5 && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Detail 5 </label>
                <label className="labelInfoModal"> {selectedRow.text5}</label>
              </div>
            )}
          </AvForm>
        </Row>
      </div>
    </>
  );
};

IForm.propTypes = {
  selectedRow: PropTypes.shape({
    Number: PropTypes.string,
    Operation: PropTypes.string,
    taskId: PropTypes.string,
    id: PropTypes.number,
    ClientId: PropTypes.string,
    dateOfi: PropTypes.string,
    timeOfi: PropTypes.string,
    user: PropTypes.string,
    text1: PropTypes.string,
    text2: PropTypes.string,
    text3: PropTypes.string,
    text4: PropTypes.string,
    text5: PropTypes.string,
    WRNUMBER: PropTypes.string,
    createdAt: PropTypes.string,
  }),
};

export default IForm;
